import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  firebaseUser: { displayName: "", email: "" },
  spannerUserId: "",
  depotUserList: [],
};

export const userSlice = createSlice({
  name: "vs_user",
  initialState,
  reducers: {
    setFirebaseUser: (state, action) => {
      state.firebaseUser = action.payload;
    },
    setUserDetails: (state, action) => {
      state.firebaseUser = action.payload.firebaseUser;
      state.spannerUserId = action.payload.spannerUserId;
      state.depotUserList = action.payload.depotUserList;
    },
  },
});

const { reducer, actions } = userSlice;
const { setFirebaseUser, setUserDetails } = actions;
export { initialState, reducer, setFirebaseUser, setUserDetails };
